/** Header menu contents */

export const PRODUCTION_HOSTNAMES = ["liquidnoble.com", "liquid.vip"];

export const REGISTRATION_HOSTNAMES = [
  "register.liquidnoble.com",
  "get.lqn.app",
];
export const REGISTRATION_URL = "https://liquidnoble.com/register/";
export const REFERRAL_PORTAL_HOSTNAME = "liquid.vip";

export const REFERRAL_REGEXES = [
  /^(\w+\.)+referral-dev\.liquidnoble\.com$/,
  /^(\w+\.)+liquid\.vip$/,
];

// Dynamically replaced by rollup.config.js - do not change
export const APP_URL = "WEB_APP_URL";
export const REDEEM_URL = "https://redeem.lqn.au";

// External resource URLs
export const LEGAL_DOCS_URL = "/legal/";
export const GENERIC_DOCS_URL = "/docs/";
export const PRIVACY_POLICY = "/legal/privacy-policy";
export const TERMS_AND_CONDITIONS = "/legal/terms-and-conditions";
export const COOKIE_POLICY = "/legal/cookie-policy";
export const AML_POLICY = "/legal/aml-ctf-policy";
export const SIGN_IN_LINK = "/register/";
export const CONTACT_EMAIL = "mailto:hello@liquidnoble.com";

// Social links

export const TELEGRAM_URL = "https://t.me/+5GXs7ZBlhi1lMWNk";
export const LINKEDIN_URL = "https://linkedin.com/company/liquid-noble";
export const TWITTER_URL = "https://twitter.com/LiquidNobleGold";
export const FACEBOOK_URL = "https://www.facebook.com/LiquidNoble";
export const INSTAGRAM_URL = "https://www.instagram.com/liquidnoblegold/";

// Referral portal enforces referral code presence
export const isReferralPortal = () => {
  return window.location?.hostname === REFERRAL_PORTAL_HOSTNAME;
};

export const isDynamicReferralPage = () => {
  const hostname = window.location?.hostname;
  if (!hostname) {
    return false;
  }

  for (const regex of REFERRAL_REGEXES) {
    if (regex.test(hostname)) {
      return true;
    }
  }
  return false;
};
